import type { ExternalProviderBatchRequestVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const adminRetrieveExternalProviderBatchRequestList = createApiThunk<ExternalProviderBatchRequestVM[], void>(
  "externalProviderBatchRequests/adminRetrieveExternalProviderBatchRequestList",
  async (_: void, { extra: { adminRepository } }) => {
    return adminRepository!.listExternalProviderBatchRequests();
  },
);
